// Single Article Mini Banner

<template>
	<div class="art-mini-main" ref="artMini" @click="clickShow">

		<div class="art-thumb-frame">
			<div class="art-thumb-image">
				<img :src="imgUrl" v-if="rec.thmName"/>
				<img :src="imgUrlNone" v-else/>
			</div>
		</div>

		<div class="art-title">
			{{ rec.title }}
		</div>				

		<div v-if="role=='adm'" class="box-adm">

			<div class="btn-edit" @click.stop="clickEdit">
				<UniIcon 
					ico="pencil"
					fit="1"
					pad="3"
					color="#FFF"
				/>
			</div>
			<div v-if="!published" class="box-pub">
				<UniIcon 
					ico="asterisk"
					fit="1"
					pad="6"
					color="#C30"
				/>
			</div>
		</div>
		
		<div class="art-sub-title">
			{{ ((role=='adm')? rec.dateVis: rec.dateVis.substr(0,12)) }}
		</div>

		<div class="art-cat-title">
			{{ rec.cat.title }}
		</div>
	
	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
import { eventBus } from '@/main';
export default {
	data() {
		return {
			imgUrl: "",
			published: true,
		}
	},
	computed: {
		...mapState('api', ['source']),
	},
	props: {
		rec: {},
		idx: Number,
		role: String,
	},
	methods: {
		calcColor(n) {
			return (n%2==0)? "even": "odd";
		},
		clickShow() {
			m("click show");
			let payload = {
				popType: "win",
				popTitle: this.rec.title,
				compName: "ArtDetail",
			};

			let data = {
				art: this.rec,
			}
			m("mini art data", data);
			this.$store.dispatch('app/setArt', data)
				.then(eventBus.$emit("popup", payload)
			)

		},
		clickEdit() {
			m("click edit");
			let payload = {
				popType: "win",
				popTitle: "Admin: Edit Article",
				compName: "AdmEdit",
			};

			let data = {
				art: this.rec,
			}
			this.$store.dispatch('app/setArt', data)
				.then(eventBus.$emit("popup", payload)
			)
		},
	},
	created() {
		this.imgUrl = this.source.url + this.source.doc + this.rec.dir + '/' + this.rec.thmName;
		this.imgUrlNone = this.source.url + this.source.doc + '/img/no_img_072_054.png';
		this.published = this.rec.live=='1' && this.rec.merit=='ok' && this.rec.stage == 'ok';
	},
	mounted() {
		// m("art mini mounted " + this.idx, this.rec);
		setTimeout(() => {
			const obj = this.$refs.artMini;
			const className = "art-mini-main show " + this.calcColor(this.idx);
			if (obj) obj.className = className;
		}, (this.idx + 1) * 100);
	}
}
</script>

<style scoped>

.art-mini-main {
	height:65px;
	cursor: pointer;
	overflow: hidden;
	white-space: nowrap;
	padding: 5px 10px 0px 0px;
	border: solid 0px #C30;
	border-bottom: solid 1px #666;

	position: relative;
	left: -100%;
	transition-duration: .3s;
	transition-timing-function: ease-in-out;

}

.hide {
	transform: translateX(-100%);
}

.show {
	transform: translateX(100%);
}


.even {
	background-color: #F3EEEC;
}

.odd {
	background-color: #F9F6F3;
}

.art-thumb-frame {
	float:left;
	width: 72px;
	height:54px;
	overflow: hidden;
	background-color: #EEE;
	border-radius:6px;
	border: solid 1px #999;
}

/* Center img inside frame, might be smaller/larger than frame */
.art-thumb-image {
	display:inline-block;
	position: relative;
	top: 50%;
	left: 50%;
	-webkit-transform: translateX(-50%) translateY(-50%);
	-moz-transform: translateX(-50%) translateY(-50%);
	-ms-transform: translateX(-50%) translateY(-50%);
	-o-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
	border: solid 0px #C30;
}

.art-title {
	float: left;
	width: calc(100% - 140px);
	height: 30px;
	font-size: 17px;
	white-space: nowrap;
	overflow: hidden;
	padding: 0px 0px 0px 10px;
	border: solid 0px #090;
}

.box-adm {
	float:right;
	width: 60px;
	height: 30px;
	overflow: hidden;
	padding: 0px 0px 0px 0px;
	border: solid 0px #090;
}

.art-sub-title {
	float: left;
	width: calc(100% - 200px);
	height: 20px;
	overflow: hidden;
	white-space: nowrap;
	font-size: 15px;
	color: #963;
	padding: 0px 0px 0px 10px;
	border: solid 0px #69C;
}

.art-cat-title {
	float: right;
	width: 120px;
	height: 20px;
	overflow: hidden;
	white-space: nowrap;
	font-size: 15px;
	text-align: right;
	color: #963;
	padding: 0px 0px 0px 0px;
	border: solid 0px #C30;
}

.btn-edit {
	float:right;
	width: 28px;
	height: 28px;
	cursor: pointer;
	padding: 0px 0px 0px 0px;
	border-radius: 6px;
	border-top: solid 1px #FFF;
	border-left: solid 1px #FFF;
	border-right: solid 1px #666;
	border-bottom: solid 1px #666;
	background : #6A9;
}

.box-pub {
	float:right;
	width: 28px;
	height: 28px;
	overflow: hidden;
	border: solid 0px #C30;
}
</style>
